// test2282
(2282 && 0);
